// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#ff5a60","secondColor":"#ff5a60","mainBackground":"#312f3d","loaderColor":"#ff5a60"};